'use client';

import type { GlobalVtwSettingsStoryblok } from '@/types/component-types-sb';
import React, { createContext, useContext } from 'react';

interface SettingsProviderProps {
  settings: GlobalVtwSettingsStoryblok;
  children: React.ReactNode;
}

const SettingsContext = createContext<GlobalVtwSettingsStoryblok | null>(null);

const VtwSettingsProvider: React.FC<SettingsProviderProps> = (props) => {
  return <SettingsContext.Provider value={props.settings}>{props.children}</SettingsContext.Provider>;
};

export const useVtwSettings = () => useContext<GlobalVtwSettingsStoryblok | null>(SettingsContext);

export default VtwSettingsProvider;
